import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Shield, TrendingUp, Users, MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../lib/constants';
export function BusinessSection() {
  return <section className="bg-mobal-white py-20 overflow-hidden" id="contacto" data-id="element-13">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 max-w-7xl mx-auto mb-16" data-id="element-15">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-3/5" data-id="element-16">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-mobal-black mb-2 uppercase leading-tight" data-id="element-17">
              EMPRESAS Y <br data-id="element-18" />
              COMERCIOS <span className="text-[#22C55E]" data-id="element-19">SIN PLAGAS</span>
            </h2>

            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 mb-8 mt-6" data-id="element-20">
              <div data-id="element-21">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-mobal-black" data-id="element-22">
                  Cumplimiento sanitario garantizado
                </h3>
                <p className="text-[#22C55E] font-bold italic text-lg mt-1" data-id="element-23">
                  Evitá clausuras, sanciones y protegé tu reputación.
                </p>
              </div>

              <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg border border-gray-100 sm:max-w-[200px]" data-id="element-24">
                <div className="bg-[#22C55E] rounded-full p-1.5 flex-shrink-0" data-id="element-25">
                  <CheckCircle2 className="w-5 h-5 text-mobal-white" data-id="element-26" />
                </div>
                <p className="text-xs font-bold text-mobal-black leading-tight" data-id="element-27">
                  Cumplí hoy.
                  <br data-id="element-28" />
                  Evitá problemas mañana.
                </p>
              </div>
            </div>

            <div className="space-y-6 mb-10 text-gray-700 font-body text-lg" data-id="element-29">
              <p data-id="element-30">
                Trabajamos con restaurantes, locales gastronómicos, depósitos y
                empresas que necesitan mantener sus espacios libres de plagas y
                cumplir con las normativas sanitarias vigentes.
              </p>
              <p data-id="element-31">
                Nos encargamos de todo:{' '}
                <span className="text-[#22C55E] font-bold underline decoration-2 underline-offset-4" data-id="element-32">
                  inspección, tratamiento
                </span>{' '}
                y{' '}
                <span className="text-[#22C55E] font-bold underline decoration-2 underline-offset-4" data-id="element-33">
                  seguimiento continuo
                </span>{' '}
                para que tu negocio funcione sin riesgos ni interrupciones.
              </p>
            </div>

            <ul className="space-y-5 mb-10" data-id="element-34">
              <li className="flex items-start gap-4" data-id="element-35">
                <div className="bg-[#22C55E] rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-36">
                  <CheckCircle2 className="w-5 h-5 text-mobal-white" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <h4 className="font-bold text-mobal-black uppercase" data-id="element-39">
                    CERTIFICADOS VÁLIDOS PARA HABILITACIONES
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-40">
                    Documentación oficial para auditorías y habilitaciones.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-41">
                <div className="bg-[#22C55E] rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-42">
                  <CheckCircle2 className="w-5 h-5 text-mobal-white" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h4 className="font-bold text-mobal-black uppercase" data-id="element-45">
                    INFORMES TÉCNICOS PROFESIONALES
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-46">
                    Informes claros, detallados y listos para presentar.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-47">
                <div className="bg-[#22C55E] rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-48">
                  <CheckCircle2 className="w-5 h-5 text-mobal-white" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h4 className="font-bold text-mobal-black uppercase" data-id="element-51">
                    PLANES DE MANTENIMIENTO MENSUAL
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-52">
                    Prevención constante para evitar re-infestaciones.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-53">
                <div className="bg-[#22C55E] rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-54">
                  <CheckCircle2 className="w-5 h-5 text-mobal-white" data-id="element-55" />
                </div>
                <div data-id="element-56">
                  <h4 className="font-bold text-mobal-black uppercase" data-id="element-57">
                    ATENCIÓN RÁPIDA EN ROSARIO Y ALREDEDORES
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-58">
                    Respuesta ágil cuando más lo necesitás.
                  </p>
                </div>
              </li>
            </ul>

            <div className="flex flex-col items-start gap-4" data-id="element-59">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#22C55E] hover:bg-[#16a34a] text-mobal-white font-bold py-5 px-10 rounded-lg transition-colors min-h-[60px] text-xl w-full sm:w-auto shadow-lg" data-id="element-60">
                <MessageCircle className="w-6 h-6" data-id="element-61" />
                SOLICITAR PRESUPUESTO
              </a>
              <div className="flex items-center gap-2 text-gray-600 text-sm font-medium ml-2" data-id="element-62">
                <ShieldCheck className="w-4 h-4 text-[#22C55E]" data-id="element-63" />
                Respuesta rápida y asesoramiento sin compromiso.
              </div>
            </div>
          </motion.div>

          {/* Right Side - Technician Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-2/5" data-id="element-64">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-65">
              <img src="https://cdn.magicpatterns.com/uploads/7GamHUDP3FuixdutcnRmva/imagen_empresas(1).jpg" alt="Técnico profesional realizando fumigación en comercio" className="w-full h-auto max-h-[500px] lg:max-h-none object-cover rounded-2xl" data-id="element-66" />
            </div>
          </motion.div>
        </div>

        {/* Bottom Benefit Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-7xl mx-auto" data-id="element-67">
          {[{
          icon: ShieldCheck,
          title: 'EVITÁ CLAUSURAS',
          desc: 'Cumplí con las normativas sanitarias.'
        }, {
          icon: Shield,
          title: 'IMAGEN QUE GENERA CONFIANZA',
          desc: 'Ambientes limpios y seguros para tus clientes.'
        }, {
          icon: TrendingUp,
          title: 'MENOS RIESGOS, MÁS PRODUCTIVIDAD',
          desc: 'Evitá pérdidas, daños y problemas en tu operación.'
        }, {
          icon: Users,
          title: 'EQUIPO PROFESIONAL',
          desc: 'Técnicos capacitados y productos autorizados.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm flex flex-col items-center text-center gap-3" data-id="element-68">
              <item.icon className="w-10 h-10 text-[#22C55E] mb-2" data-id="element-69" />
              <h4 className="font-bold text-mobal-black text-xs md:text-sm uppercase" data-id="element-70">
                {item.title}
              </h4>
              <p className="text-gray-500 text-xs md:text-sm" data-id="element-71">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}